export default "__VITE_ASSET__BQsn7FZg__"